import { CommonModule } from '@angular/common';
import { SimpleDropdownModule } from 'Angular/features/components/dropdowns/simple-dropdown/simple-dropdown.module';
import { DisabledModule } from 'Angular/features/directives/disabled/disabled.module';
import { IconModule } from 'Angular/features/directives/icon/icon.module';
import { TooltipModule } from 'Angular/features/directives/popovers/tooltip/tooltip.module';
import { FoldersSharedModule } from 'FoldersApp/features/folders-shared/app.module';
import { GetOwnerDisplayNamePipeModule } from 'SharingApp/ts/pipes/get-owner-display-name.module';
import { GetSharingTooltipMessagePipeModule } from 'SharingApp/ts/pipes/get-sharing-tooltip-message.module';
import { IsSharedWithOthersPipeModule } from 'SharingApp/ts/pipes/is-shared-with-others-pipe.module';
import * as i0 from "@angular/core";
export class HypotheticalsSharedModule {
}
HypotheticalsSharedModule.ɵfac = function HypotheticalsSharedModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || HypotheticalsSharedModule)(); };
HypotheticalsSharedModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: HypotheticalsSharedModule });
HypotheticalsSharedModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [CommonModule,
        DisabledModule,
        FoldersSharedModule,
        GetOwnerDisplayNamePipeModule,
        GetSharingTooltipMessagePipeModule,
        IconModule,
        IsSharedWithOthersPipeModule,
        SimpleDropdownModule,
        TooltipModule] });
